import React from "react";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedinIn, FaYoutube } from "react-icons/fa";


const FooterCard7 = () => {
  return (<>
    <footer className="footer-fc-7">

      {/* Wavy Top Shape */}
      <div className="footer-fc-7-wave"></div>

      <div className="footer-fc-7-container">

        {/* Useful Links */}
        <div className="footer-fc-7-col">
          <h3>Useful Links</h3>
          <ul>
            <li>About Us</li>
            <li>Services</li>
            <li>Case Study</li>
            <li>Blogs</li>
            <li>Support</li>
            <li>FAQ</li>
            <li>Contact Us</li>
          </ul>
        </div>

        {/* About / Center Section */}
        <div className="footer-fc-7-col center">
          <div className="footer-fc-7-logo">AI MACHINE LEARNING</div>

          <p className="footer-fc-7-text">
            Lorem Ipsum is simply dummy text of the printing and typesetting 
            industry. Lorem Ipsum has been the industry's standard dummy text 
            ever since the 1500s, when an unknown printer took a galley of type.
          </p>

          <div className="footer-fc-7-social">
            <span> <FaFacebookF />
                      </span>
            <span>  <FaTwitter />
                      </span>
            <span>  <FaInstagram />
                        </span>
            <span><FaLinkedinIn />
                      </span>
          </div>
        </div>

        {/* Contact */}
        <div className="footer-fc-7-col">
          <h3>Contact Us</h3>

          <p className="footer-fc-7-label">Phone</p>
          <p className="footer-fc-7-value">+12 3456789123</p>

          <p className="footer-fc-7-label">Email</p>
          <p className="footer-fc-7-value">aimachine@gmail.com</p>

          <p className="footer-fc-7-label">Address</p>
          <p className="footer-fc-7-value">Westheimer Rd. Santa Ana, Illinois</p>

          <button className="footer-fc-7-buy">Buy Now</button>
        </div>

      </div>

      <div className="footer-fc-7-bottom">
        © 2025 AI Machine Learning — All Rights Reserved.
      </div>
 <div className=""style={{marginBottom:"-10px"}} aria-hidden>
          <svg viewBox="0 0 1440 120" preserveAspectRatio="none"><path d="M0 40 C 360 120 1080 -40 1440 40 L1440 120 L0 120 Z" fill="#333333"/></svg>
        </div>
    </footer>
    <style>{`.footer-fc-7 {
  background:  rgba(144, 202, 249,0.81);
  color: white;
  margin-top: 50px;
  position: relative;
  font-family: Arial, sans-serif;
}

/* Wavy shape */
.footer-fc-7-wave {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 140px;
  background: rgba(144, 202, 249,0.91);
  border-bottom-left-radius: 50% 20% ;
  border-bottom-right-radius: 50% 20%;
}

/* Layout */
.footer-fc-7-container {
  display: flex;
  justify-content: space-between;
  padding: 40px 80px;
  flex-wrap: wrap;
  z-index: 2;
  position: relative;
}

.footer-fc-7-col {
  width: 30%;
  min-width: 250px;
}

.footer-fc-7-col h3 {
  margin-bottom: 15px;color: #003342;;
  font-size: 20px;
  border-bottom: 2px solid #003342;;
  display: inline-block;
  padding-bottom: 5px;
}

.footer-fc-7-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.footer-fc-7-col ul li {
  margin-bottom: 10px;
  cursor: pointer;color: #003342;;
  opacity: 0.85;
}

.footer-fc-7-col ul li:hover {
  opacity: 1;
}

/* Center column */
.center {
  text-align: center;
}

.footer-fc-7-logo {
  font-size: 22px;
  font-weight: bold;
  margin-bottom: 15px;
}

.footer-fc-7-text {color: #003342;;
  max-width: 380px;
  margin: 0 auto 20px auto;
  line-height: 1.6;
  opacity: 0.9;
}

/* Social icons */
.footer-fc-7-social span {
  background: rgba(255,255,255,0.2);color: #003342;;
  padding: 10px 14px;
  border-radius: 6px;
  margin: 0 6px;
  display: inline-block;
  cursor: pointer;
}

.footer-fc-7-social span:hover {
  background: rgba(255,255,255,0.35);
}

/* Labels */
.footer-fc-7-label {
  font-size: 14px;
  opacity: 0.7;
  margin-top: 12px;
}

.footer-fc-7-value {
  font-size: 16px;
  margin-bottom: 8px;color: #003342;;
}

/* Button */
.footer-fc-7-buy {
  background: rgba(144, 202, 249,1);
  border: none;
  margin-top: 12px;
  padding: 10px 22px;
  border-radius: 20px;
  cursor: pointer;
  font-weight: bold;
  color: #003342;
}

.footer-fc-7-buy:hover {
  background: #00a7d8;
}

/* Footer bottom */
.footer-fc-7-bottom {
  text-align: center;
  padding: 25px;
  margin-top: 20px; color:  #111;;
  border-top: 1px solid rgba(255,255,255,0.2);
  opacity: 0.8;
}

/* Responsive */
@media (max-width: 900px) {
  .footer-fc-7-container {
    flex-direction: column;
    text-align: center;
  }

  .footer-fc-7-col {
    width: 100%;
    margin-bottom: 30px;
  }
}
`}</style>
    </>
  );
};

export default FooterCard7;
